export enum PageName {
  HOME = "Home"
}